<template>
<div class="cField" id="noticeWrap">
	<window-for-view :id="id" :bg="true" class="notice" ref="Window">
		<div slot="head" class="head bdSub-bottom bg">
			<span class="mt05x fs12x">全部消息</span>
			<div class="fR cField fField hover-f-main_E hover-c-main_E tra-fast_E vaM_E">
				<button class="hover-f-error" :title="$t('cmd153',['关闭'])" type="button" @click="clearNotice">清空全部</button>
			</div>
		</div>
		<div class="posR">
			<loading v-show="isLoading"></loading>
			<div fillHeight="lastHeight" scroll>
				<ul class="msgList bdSub-bottom_E">
					<!-- 导致卡顿
					<li class="pt1x pb1x flexSys pl3x pr3x" v-for="(item,index) in msgList" :key="index" @click="readNotice(item)">
						<div class="mr1x posR flexAlarm" :class="{round:item.read==false}">
							<div class="icoSys bgAlarm w3x h3x">
								<svg class="fWhite"><use xlink:href="#ico-alarm"></use></svg>
							</div>
						</div>
						<div class="flex1">
							<div class="clearfix">
								<span class="fs12x">{{getTypeText(item.messageType,'noticeType')}}</span>
								<span class="fR cSub">{{item.createTime|time("%Y/%m/%d")}}&nbsp;&nbsp;{{item.createTime|time("%H:%M:%S")}}</span>
							</div>
							<div class="lh15"><span class="cMain curP" @click="viewDetails(item.objectId,item.objectType)">{{item.objectName}}</span>{{item.messageContent}}</div>
						</div>
					</li>
					 -->
				</ul>
			</div>
			<no-result v-show="!isLoading && !msgList.length"></no-result>
		</div>
	</window-for-view>
	<ViewDetail ref="ViewDetail" :basicInfo="basicInfo" :basicCost="basicCost" @refresh="viewDetails(stationId)"></ViewDetail>
</div>
</template>
<script>
import {mapActions,mapGetters,mapMutations} from 'vuex'
import WindowForView from '@/components/common/ui/WindowForView'
import Loading from '@/components/common/ui/Loading'
import ViewDetail from "@/view/maintain/light/plant/ViewDetail.vue"
import NoResult from '@/components/common/ui/NoResult'
import * as lib from "@/util/lib"
import {deleteInbox,readInbox,StationBasicInfo,StationCost} from '@/api/maintain/plant/list'

export default {
	name : 'notice',
	components:{
		WindowForView,
		ViewDetail,
		NoResult,
		Loading
	},
	data(){
		return{
			id:"notice"+Math.round(Math.random()*99999),
			basicInfo:{},//详情-电站信息
			basicCost:{},//详情-电站信息-电价
			isLoading:true
		}
	},
	watch:{
		$route(to,from){
			if(to.path !=from.path ){
			//	setTimeout(this.GETMSGLIST,1000);
				if(this.isOpen==true) {
					this.$refs.ViewDetail.myClose()
				}
				if(this.isProjectOpen==true){
					this.GET_ISPROJECWINOPEN({type: 'projectDetail/GET_ISWINOPEN', isWinOpen: false})
					this.GET_PROJECTBTNINDEX({type: 'projectDetail/GET_PROJECTBTNINDEX', index: 0})
				}
			}
		}
	},
	methods:{
		getTypeText:lib.getTypeText,
		...mapMutations({
			CHANGE:'equipment/CHANGE',
			// GET_STATIONID:'stationDetail/GET_STATIONID',
			// GET_ISEMPTY:'stationDetail/GET_ISEMPTY',
			// GET_BTNGROUP:'stationDetail/GET_BTNGROUP',
			// GET_CURRENTINDEX:'stationDetail/GET_CURRENTINDEX',
			GET_ISNOTICEBOX:'inbox/GET_ISNOTICEBOX',
			GET_PROJECTBTNINDEX:'projectDetail/GET_PROJECTBTNINDEX',
			GET_ISPROJECWINOPEN: 'projectDetail/GET_ISWINOPEN',
		}),
		...mapActions({
			GetEquipment:'stationDetail/GetEquipment',
			GetPerson:'stationDetail/GetPerson',
			GETMSGLIST:'inbox/GETMSGLIST',
		}),
        close(){
			this.$refs.Window.hide();
			this.$nextTick(()=>{
				this.GET_ISNOTICEBOX(false)
			})
		},
		show(){
			this.$refs.Window.show();
			this.isLoading=true
			this.GETMSGLIST().then(res=>{
				this.isLoading=false
			})
		},
		//清空全部
		clearNotice(){
			if(this.msgList.length>0){
				deleteInbox().then(res=>{
					this.isLoading=true
					this.GETMSGLIST().then(res=>{
						this.isLoading=false
					})
				},error=>{
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		//标记为已读
		readNotice(item){
			if(!item.read){
				readInbox(item.id).then(res=>{
					this.isLoading=true
					this.GETMSGLIST().then(res=>{
						this.isLoading=false
					})
				},error=>{
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		//展开详情
		viewDetails(id,type){
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			switch(type){
				case 'STATION':
					if(!buttonPermissions.includes('A/B/F')){
						return this.$notify(`查看电站详情没有权限。`)
					}
					this.GET_STATIONID(id) //获取列表id
					if(this.$route.fullPath =='/maintain/plant/list'){
						this.GET_ISNOTICEBOX(true)
					}else{
						this.basicInfo={}
						this.basicCost={}
						this._getBasicInfo(id)//电站信息
						this._getBasicCost(id)//电站信息
						this.CHANGE(3)
						let pages={page:1,size:20,equipTabIndex:this.deviceIndex}
						if(this.btnGroup[this.currentIndex].Perms=='A/D/A'){
							this.GetPerson(pages).then(()=>{
							}).catch(error=>{
								!_.isEmpty(error) && this.$notify(error)
								this.GET_ISEMPTY(false)
							})
						}else if(this.btnGroup[this.currentIndex].Perms=='A/C/A'){
							this.GetEquipment(pages).then(()=>{
							}).catch(error=>{
								!_.isEmpty(error) && this.$notify(error)
								this.GET_ISEMPTY(false)
							})
						}
						this.$nextTick(()=>{
							this.$refs.ViewDetail.show()
						})
					}
					break
				case "PROJECT_PLAN":	//PROJECT
					if(!buttonPermissions.includes('E/B')){
						return this.$notify(`您暂未开通审批权限！`)
					}
					this.$router.push({ path: '/bench/approval' })
					break
				default:
					break
			}
			this.close()
		},
		//获取详情-电站信息
		_getBasicInfo(id){
			StationBasicInfo(id).then(response=>{
				this.basicInfo=response
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		//获取电站成本
		_getBasicCost(id){
			StationCost(id).then(response=>{
				this.basicCost=response
			},error=>{
				console.log(error)
			})
		},
	},
	computed:{
		...mapGetters({
			msgList:'inbox/msgList',
			// ActiveIndex:'equipment/ActiveIndex',
			// stationId:'stationDetail/stationId',
			// currentIndex:'stationDetail/currentIndex',
			// isOpen:'stationDetail/isOpen',
			// btnGroup:'stationDetail/btnGroup',
			// deviceIndex:'stationDetail/deviceIndex',
			isProjectOpen:'projectDetail/isWinOpen'
		})
	},
	mounted(){
		lib.fillHeight()
		lib.setScroll($(this.$el).find(".msgList").parent("[scroll]"));
		// this.GET_BTNGROUP()
	}
}
</script>
<style lang="scss" scoped>
#noticeWrap{
	line-height: 1.5;
	.notice{z-index: 13;}
}
.round::after{
	content: "";
	display: block;
	position: absolute;
	width:8px;
	height: 8px;
	border-radius: 100%;
	background: #ff9659;
	top: 50%;
	margin-top: -4px;
	left: -1.5em;
}
.bgAlarm{
	background: #f9565c
}
.flex1{
	flex: 1
}
ul>li:hover{
	background-color: rgba(166, 137, 121, 0.06);
}
.flexAlarm{
	display: flex;
	align-items: center
}
</style>



// WEBPACK FOOTER //
// src/view/frame/Notice.vue